import { render, staticRenderFns } from "./CircleMemo.vue?vue&type=template&id=90486ce0&lang=pug&"
import script from "./CircleMemo.vue?vue&type=script&lang=js&"
export * from "./CircleMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports